module.exports = __webpack_public_path__ + "static/media/plotter4.2cccacfb.png";